import { Text } from '@zeiss/beyond-online-react';
import { useBreakpoint } from '@zeiss/lib-helpers';

interface ModalTextProps {
  children: React.ReactNode;
}
export const ModalText = ({ children }: ModalTextProps) => {
  const isMinTablet = useBreakpoint('tablet');

  return <Text size={isMinTablet ? 'l' : 'm'}>{children}</Text>;
};
